import TrafficExchangeLogo from 'assets/logos/traffic-exchange-logo-original.svg';
import TrafficExchangeLogoWhite from 'assets/logos/traffic-exchange-logo-white.svg';
import MakeTrafficLogoWhite from 'assets/logos/make-traffic.svg';

export const AssetsAliases = {
  LogoOriginal: TrafficExchangeLogo,
  LogoWhite: TrafficExchangeLogoWhite,
  makeTrafficLogoWhite: MakeTrafficLogoWhite
};
